// Checks that the captured photo contains exactly one face (runs in the browser, nothing is uploaded).
// If the model can't load (offline, very old browser) the photo is accepted, so a technical
// problem never stops an employee from marking attendance.
let loading = null;

const load = () => {
  if (!loading) {
    loading = (async () => {
      const faceapi = await import("@vladmandic/face-api");
      await faceapi.tf.ready();
      await faceapi.nets.tinyFaceDetector.loadFromUri(`${process.env.PUBLIC_URL || ""}/models`);
      return faceapi;
    })().catch((e) => {
      loading = null; // allow a retry next time
      throw e;
    });
  }
  return loading;
};

// Start downloading the model while the camera screen is open, so the check is instant later.
export const preloadFaceModel = () => {
  load().catch(() => {});
};

const withTimeout = (p, ms) =>
  Promise.race([p, new Promise((_, rej) => setTimeout(() => rej(new Error("face model timeout")), ms))]);

export const checkFace = async (canvas) => {
  try {
    const faceapi = await withTimeout(load(), 10000);
    const faces = await faceapi.detectAllFaces(
      canvas,
      new faceapi.TinyFaceDetectorOptions({ inputSize: 320, scoreThreshold: 0.4 })
    );
    if (!faces || faces.length === 0) {
      return { ok: false, message: "No face detected. Please show your face to the camera and try again." };
    }
    if (faces.length > 1) {
      return { ok: false, message: "More than one face detected. Only you should be in the photo." };
    }
    return { ok: true };
  } catch (e) {
    console.log("[FaceCheck] skipped:", e && e.message);
    return { ok: true, skipped: true };
  }
};
